module.exports = __webpack_public_path__ + "img/5.c6ec5366.jpg";